export default "assets/background.png"